import React from "react";

import { BessResumoGeral } from "../../types";
import { formatBrazilianCurrency } from "../../../../utils/utilityFunctions";

interface BessSummaryCardsProps {
  resumo: BessResumoGeral;
}

const formatKwh = (value: number): string =>
  `${Math.round(value).toLocaleString("pt-BR")} kWh`;

const formatCiclos = (value: number): string =>
  value.toLocaleString("pt-BR", { maximumFractionDigits: 1 });

const signClass = (value: number): string =>
  value >= 0 ? "economia-positivo" : "economia-negativo";

export const BessSummaryCards: React.FC<BessSummaryCardsProps> = ({
  resumo,
}) => {
  return (
    <>
      <h4 className="bess-section-title">Resultado financeiro do mês</h4>
      <div className="bess-profit">
        <div className="bess-card bess-profit-total">
          <h1>Lucro operacional mensal</h1>
          <h2 className={signClass(resumo.lucroTotal)}>
            {formatBrazilianCurrency(resumo.lucroTotal)}
          </h2>
          <h3>soma dos quatro componentes abaixo</h3>
        </div>

        <div className="bess-profit-parts">
          <div className="bess-card bess-profit-part">
            <h1>Economia por consumo evitado</h1>
            <h2>{formatBrazilianCurrency(resumo.ganhoDescarga)}</h2>
          </div>

          <div className="bess-card bess-profit-part">
            <h1>Resultado de MCP</h1>
            <h2 className={signClass(resumo.mcpDelta)}>
              {formatBrazilianCurrency(resumo.mcpDelta)}
            </h2>
            <h3>
              com bateria {formatBrazilianCurrency(resumo.mcpTotal)} · sem
              bateria {formatBrazilianCurrency(resumo.mcpTotalSemBess)}
            </h3>
          </div>

          <div className="bess-card bess-profit-part">
            <h1>Custo de carga (rede)</h1>
            <h2>{formatBrazilianCurrency(resumo.custoCargaRede)}</h2>
          </div>

          <div className="bess-card bess-profit-part">
            <h1>Benefício tarifário</h1>
            <h2 className={signClass(resumo.beneficioTarifarioDelta)}>
              {formatBrazilianCurrency(resumo.beneficioTarifarioDelta)}
            </h2>
          </div>
        </div>
      </div>

      <h4 className="bess-section-title">Energia no mês</h4>
      <div className="bess-cards">
        <div className="bess-card">
          <h1>Energia carregada</h1>
          <h2>{formatKwh(resumo.energiaCarregadaAcKwh)}</h2>
          <h3>
            rede {formatKwh(resumo.energiaCarregadaRedeKwh)} · solar{" "}
            {formatKwh(resumo.energiaCarregadaSolarKwh)}
          </h3>
        </div>

        <div className="bess-card">
          <h1>Energia entregue</h1>
          <h2>{formatKwh(resumo.energiaEntregueAcKwh)}</h2>
          <h3>
            consumo{" "}
            {formatKwh(resumo.energiaEntregueAcKwh - resumo.energiaInjetadaKwh)}{" "}
            · injetada {formatKwh(resumo.energiaInjetadaKwh)}
          </h3>
        </div>

        <div className="bess-card">
          <h1>Ciclos equivalentes</h1>
          <h2>{formatCiclos(resumo.ciclosEquivalentes)}</h2>
        </div>
      </div>
    </>
  );
};
